import { useMemo } from 'react';

import Box from '@zenbusiness/zui/Box';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import useCheckTransactionContext from '#client/hooks/useCheckTransactionContext';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';
import useSkeleton from '#client/hooks/useSkeleton';
import useUnitAccount from '#client/hooks/useUnitAccount';
import { formatHistoryBalance } from '#client/utils/chart';

import { ChartContainer } from './BankingChart.styles';
import Chart from './components/Chart';
import ChartSkeleton from './components/ChartSkeleton';
import EmptyChart from './components/EmptyChart';
import Title from './components/Title';

export default function HistoryBalanceChart() {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const { unitAccount, error: unitAccountError, loading: loadingUnitAccount } = useUnitAccount();
  const { loading, hasTransaction, error: transactionError } = useCheckTransactionContext();
  const { isDisable } = useDisableDashboardContext();

  const dailyBalances = useMemo(
    () => formatHistoryBalance(unitAccount?.balanceHistories),
    [unitAccount?.balanceHistories]
  );

  const error = unitAccountError || transactionError;

  const isHideSkeleton = !loading && !loadingUnitAccount && (unitAccount || error || isDisable);
  const [showSkeleton] = useSkeleton(isHideSkeleton);

  if (showSkeleton) {
    return (
      <Box>
        <ChartSkeleton />
      </Box>
    );
  }

  if (error) {
    return (
      <ChartContainer>
        <Title />
        <EmptyChart
          height={isMobile ? 224 : 240}
          title="Refresh the page to load data"
        />
      </ChartContainer>
    );
  }

  if (!hasTransaction) {
    return (
      <ChartContainer>
        <Title />
        <EmptyChart
          height={isMobile ? 224 : 240}
          title="NO DATA YET"
        />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer>
      <Title />
      <Chart
        dailyBalance={dailyBalances}
        height={isMobile ? 156 : 206}
      />
    </ChartContainer>
  );
}
